<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ detail__detail? 'DÉTAIL DU' : (Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN") }} FRAIS</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />

        <input type="file" class="hidden" ref="updateImgInput1" @change="updateCurrImg1" multiple accept="image/*">
        
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2" v-if="!detail__detail">

                <!-- ************************************************************************************************************* -->
                <!-- ************************************************************************************************************* -->
                <!-- ************************************************************************************************************* -->
                <!-- ************************************************************************************************************* -->


                <div v-if="!detail__detail" class="upload-img mt-5 mb-2">
                  <vs-button icon-pack="feather" icon="icon-plus" @click="$refs.updateImgInput1.click()">Preuves</vs-button>
                </div>

                <div class="carousel-example" v-if="dataImg1.length || (input.otherFeePictures && input.otherFeePictures.length)">
                  <swiper :options="swiperOption" style="height: 300px !important;">
                    <swiper-slide v-for="(data, io) in dataImg1" :key="io + '458'" @click="delete_preuve(io)">
                      <div class="items-center justify-center">
                        <vs-button
                          v-if="!detail__detail"
                          icon-pack="feather"
                          icon="icon-trash"
                          size="small"
                          color="warning"
                          @click="delete_carte_identite(io)"
                        >Supprimer</vs-button>
                        <img style="height: 300px !important;" class="responsive" :src="data" alt="banner">
                      </div>
                    </swiper-slide>

                    <swiper-slide v-for="(data, io) in input.otherFeePictures" :key="io + '45895'" @click="delete_preuve({ id: data.id, key: io })">
                      <div class="items-center justify-center">
                        <vs-button
                          v-if="!detail__detail"
                          icon-pack="feather"
                          icon="icon-trash"
                          size="small"
                          color="warning"
                          @click="delete_carte_identite({ id: data.id, key: io })"
                        >Supprimer</vs-button>
                        <img style="height: 300px !important;" class="responsive" :src="$store.state.image_url +  data.url" alt="banner">
                      </div>
                    </swiper-slide>
                    
                    <!-- <swiper-slide>
                      <img style="height: 300px !important;" class="responsive" src="@/assets/images/pages/carousel/banner-13.jpg" alt="banner">
                    </swiper-slide>
                    <swiper-slide>
                      <img style="height: 300px !important;" class="responsive" src="@/assets/images/pages/carousel/banner-4.jpg" alt="banner">
                    </swiper-slide>
                    <swiper-slide>
                      <img style="height: 300px !important;" class="responsive" src="@/assets/images/pages/carousel/banner-2.jpg" alt="banner">
                    </swiper-slide> -->
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                  </swiper>
                </div>

                <!-- ************************************************************************************************************* -->
                <!-- ************************************************************************************************************* -->
                <!-- ************************************************************************************************************* -->
                <!-- ************************************************************************************************************* -->

                <p class="mt-5" >Date de paiement<b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                <datepicker :disabled="detail__detail" v-model="input.paymentDate"></datepicker>
                <span v-if="error.paymentDate || all_errors.paymentDate.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.paymentDate" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Type Frais <b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                <v-select :disabled="detail__detail" 
                  :reduce="rep => rep.id" class="w-full" label="name" v-model="input.storeOutlay" :options="storeOutlays"></v-select>
                <span v-if="error.storeOutlay || all_errors.storeOutlay.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.storeOutlay" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Magasin <b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                <v-select :disabled="detail__detail" 
                  :reduce="rep => rep.id" class="w-full" label="name" v-model="input.store" :options="stores"></v-select>
                <span v-if="error.store || all_errors.store.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.store" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Montant <!-- <b style="color: #ff6141" v-if="!detail__detail" >*</b> --> </p>
                <vs-input-number class="w-full" v-model="input.amount"/>
                <span v-if="error.amount || all_errors.amount.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.amount" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Description </p>
                <vs-textarea 
                  counter="255" :counter-danger.sync="counterDanger"
                  :disabled="detail__detail"
                  v-model="input.wording" height="200" />

            </div>
            <vs-list v-if="detail__detail">
              <vs-list-header icon-pack="feather" icon="icon-globe" title="Information"></vs-list-header>
              
              <vs-list-item icon-pack="feather" icon="icon-check" title="Date de paiement" :subtitle="convertDateTime(new Date(input.paymentDate)).date"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-shield" title="Type de frais" :subtitle="input.storeOutlay_all.name"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-shield" title="Magasin" :subtitle="input.store_all.name"></vs-list-item>



              <vs-list-header icon-pack="feather" icon="icon-dollar-sign" title="Inormation sur le montant" color="success"></vs-list-header>
                  
              <vs-list-item icon-pack="feather" icon="icon-check" title="Montant payé" :subtitle="String(input.amount)"></vs-list-item>
            </vs-list>
        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    var base_self;
    var input_tempon = {
      id: null,
      store: '',
      paymentDate: '',
      storeOutlay: '',
      wording: '',
      amount: 0,
    };
    
    import 'swiper/dist/css/swiper.min.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    import Datepicker from 'vuejs-datepicker';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';


    export default {
        components: {VuePerfectScrollbar, Datepicker, swiper, swiperSlide},
        props: {
            isSidebarActive: {
              type: Boolean,
              required: true
            },
            data: {
              type: Object,
              default: () => {},
            },
        },
        data() {
            return {
              counterDanger: false,
              dataImg1: [],
              dataImg1_delete: [],
              dataImg1_file: [],
              swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev'
                }
              },
              initialNoError: {
                store: false,
                storeOutlay: false,
                paymentDate: false,
                wording: false,
                amount: false,
              },
              error: {
                store: false,
                storeOutlay: false,
                paymentDate: false,
                wording: false,
                amount: false,
              },
                all_errors: {
                  name: [],
                  store: [],
                  storeOutlay: [],
                  paymentDate: [],
                  wording: [],
                  amount: [],
                },
                stores: [],
                storeOutlays: [],
                input: JSON.parse(JSON.stringify(input_tempon)),
                input1: JSON.parse(JSON.stringify(input_tempon)),
                detail__detail: false,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
            isFormValid() {
              var is_valide = true;
              if (!base_self.input.paymentDate || base_self.input.paymentDate === '') is_valide = false;
              if (!base_self.input.storeOutlay || base_self.input.storeOutlay === '') is_valide = false;
              if (!base_self.input.store || base_self.input.store === '') is_valide = false;
              if (!base_self.input.amount || base_self.input.amount === '') is_valide = false;

              if (base_self.input.id) {
                if (!base_self.dataImg1.length && !base_self.input.otherFeePictures) is_valide = false;
              } else {
                if (!base_self.dataImg1.length) is_valide = false;
              }

              return is_valide;
            }
        },
        methods: {
            convertDateTime (dateTimeSysteme) {
              let date = dateTimeSysteme.getFullYear() + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + ('0' + dateTimeSysteme.getDate()).slice(-2);
              let time = ('0' + dateTimeSysteme.getHours()).slice(-2) + ':' + ('0' + dateTimeSysteme.getMinutes()).slice(-2) + ':' + ('0' + dateTimeSysteme.getSeconds()).slice(-2);
              let dateTime = date + ' ' + time;

              return { dateTime, date, time };
            },
            async delete_carte_identite(data) {
              if (data.id) {
                base_self.dataImg1_delete.push(data.id);
                base_self.input.otherFeePictures.splice(data.key, 1);
              } else {
                base_self.dataImg1.splice(data.key, 1);
              }
            },
            async delete_preuve(data) {
              this.$vs.dialog({
                type:'confirm',
                color: 'danger',
                title: 'Confirmation',
                text: 'Confirmer la suppression?',
                acceptText: 'Confirmer',
                cancelText: 'Annuler',
                accept: async () => {
                  if (data.id) {
                    base_self.dataImg1_delete.push(data.id);
                    base_self.input.otherFeePictures.splice(data.key, 1);
                  } else {
                    base_self.dataImg1.splice(data.key, 1);
                  }
                  /* base_self.$store.state.guardian_delete(id)
                    .then ((response) => {
                      window.getAgroTrack.success('La photo est supprimé avec succès.', response);
                      base_self.getGuardians();
                    })
                    .catch(() => {
                      window.getAgroTrack.error({ message: 'La suppression de la photo a échoué.' });
                    }); */
                }
              })
            },
            async getStoreOutlays () {
              let reponse = await base_self.$store.state.storeOutlays({})
              base_self.storeOutlays = reponse.data.results
            },
            async getStores () {
              let reponse = await base_self.$store.state.stores({})
              base_self.stores = reponse.data.results
            },
            verification_wording () {
              let libelle = 'La description est réquise.';
              if (!base_self.initialNoError.wording) return false;
              if (base_self.input.wording.length === 0) {
                base_self.all_errors.wording.push(libelle)
              } else {
                base_self.all_errors.wording = base_self.all_errors.wording.filter(e => e !== libelle);
              }
            },
            verification_paymentDate () {
              let libelle = 'Le paiement est réquis.';
              if (!base_self.initialNoError.paymentDate) return false;
              if (!base_self.input.paymentDate || base_self.input.paymentDate === '') {
                base_self.all_errors.paymentDate.push(libelle)
              } else {
                base_self.all_errors.paymentDate = base_self.all_errors.paymentDate.filter(e => e !== libelle);
              }
            },
            verification_storeOutlay () {
              let libelle = 'Le magasin est réquis.';
              if (!base_self.initialNoError.storeOutlay) return false;
              if (!base_self.input.storeOutlay || base_self.input.storeOutlay === '') {
                base_self.all_errors.storeOutlay.push(libelle)
              } else {
                base_self.all_errors.storeOutlay = base_self.all_errors.storeOutlay.filter(e => e !== libelle);
              }
            },
            verification_store () {
              let libelle = 'Le magasin est réquis.';
              if (!base_self.initialNoError.store) return false;
              if (!base_self.input.store || base_self.input.store === '') {
                base_self.all_errors.store.push(libelle)
              } else {
                base_self.all_errors.store = base_self.all_errors.store.filter(e => e !== libelle);
              }
            },
            verification_amount () {
              let libelle = 'Le montant est réquis.';
              if (!base_self.initialNoError.amount) return false;
              if (!base_self.input.amount || base_self.input.amount === '') {
                base_self.all_errors.amount.push(libelle)
              } else {
                base_self.all_errors.amount = base_self.all_errors.amount.filter(e => e !== libelle);
              }
            },
            updateCurrImg1(input) {
              if (input.target.files && input.target.files[0]) {
                let length = input.srcElement.files.length;
                for (let iuoy = 0; iuoy < length; iuoy++) {
                  var reader = new FileReader();
                  reader.onload = e => {
                    // unshift
                    base_self.dataImg1.unshift(e.target.result)
                    base_self.dataImg1_file.unshift(base_self.$refs.updateImgInput1.files[iuoy])

                  };
                  reader.readAsDataURL(input.target.files[iuoy])
                }	
              }
            },
            async submitData() {
                let convertDateTime = function (dateTimeSysteme) {
                  let date = dateTimeSysteme.getFullYear() + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + ('0' + dateTimeSysteme.getDate()).slice(-2);
                  let time = ('0' + dateTimeSysteme.getHours()).slice(-2) + ':' + ('0' + dateTimeSysteme.getMinutes()).slice(-2) + ':' + ('0' + dateTimeSysteme.getSeconds()).slice(-2);
                  let dateTime = date + ' ' + time;

                  return { dateTime, date, time };
                };

                var input = JSON.parse(JSON.stringify(this.input));

                input.paymentDate = convertDateTime(new Date(input.paymentDate)).date;
                
                var form = new FormData()
                const keys = [ 'wording', 'store', 'storeOutlay', 'amount', 'paymentDate'];
                var length = keys.length;
                var iuoy = 0;
                for (iuoy = 0; iuoy < length; iuoy++) {
                  var item = keys[iuoy];
                  form.append(item, input[item]);
                }


                if (base_self.dataImg1_delete.length) {
                  length = base_self.dataImg1_delete.length;
                  for (iuoy = 0; iuoy < length; iuoy++) {
                    form.append("pictures_remove", base_self.dataImg1_delete[iuoy]);
                  }	
                }

                if (base_self.dataImg1_file.length) {
                  length = base_self.dataImg1_file.length;
                  for (iuoy = 0; iuoy < length; iuoy++) {
                    if (input.id) {
                      form.append("pictures_add", base_self.dataImg1_file[iuoy], base_self.dataImg1_file[iuoy].name);
                    } else {
                      form.append("proof", base_self.dataImg1_file[iuoy], base_self.dataImg1_file[iuoy].name);
                    }
                  }
                } /* else {
                  if (input.id) {
                    form.append("pictures_add", null);
                  } else {
                    form.append("image", null);
                  }
                } */
                
                if(!input.id) {     
                    base_self.$store.state.otherFee_post(form)
                      .then((response) => { 
                        window.getAgroTrack.success('Le frais est ajoutée avec succès.', response);
                        window.getAppOtherFees.getOtherFees();
                        this.$emit('closeSidebar');
                        this.initValues()
                      })
                      .catch((error) => { 
                        console.log('error: ', error)
                      });
                  
                } else if (input.id) {
                    base_self.$store.state.otherFee_update(form, input.id)
                      .then((response) => { 
                        window.getAgroTrack.success('Le frais est modifiée avec succès.', response);
                        window.getAppOtherFees.getOtherFees();
                        this.$emit('closeSidebar');
                        this.initValues()
                      })
                      .catch((error) => { 
                        console.log('error: ', error)
                      });
                }
            },
            initValues() {
                this.initialNoError = {
                  store: false,
                  paymentDate: false,
                  storeOutlay: false,
                  wording: false,
                  amount: false,
                };
                base_self.input = JSON.parse(JSON.stringify(input_tempon));
                base_self.input1 = JSON.parse(JSON.stringify(input_tempon));
                base_self.detail__detail = false;
                base_self.dataImg1 = [];
                base_self.dataImg1_delete = [];
                base_self.dataImg1_file = [];
                // window.getOtherFees.sidebarData.detail__detail = false;
            }
        },
        watch: {
          input: {
            handler () {
              if (base_self.input1.paymentDate !== base_self.input.paymentDate) 
              {
                base_self.initialNoError.paymentDate = true
                base_self.verification_paymentDate()
              }

              
              if (base_self.input1.storeOutlay !== base_self.input.storeOutlay) 
              {
                base_self.initialNoError.storeOutlay = true
                base_self.verification_storeOutlay()
              }

              if (base_self.input1.store !== base_self.input.store) 
              {
                base_self.initialNoError.store = true
                base_self.verification_store()
              }

              if (base_self.input1.amount !== base_self.input.amount) 
              {
                base_self.initialNoError.amount = true
                base_self.verification_amount()
              }

              base_self.input1 = JSON.parse(JSON.stringify(base_self.input));
            },
            deep: true
          },
          async isSidebarActive() {
              this.initValues();
              if (base_self.data && base_self.data.id) {
                // Object.assign(base_self.input, JSON.parse(JSON.stringify(base_self.data)));
                base_self.input = JSON.parse(JSON.stringify(base_self.data));
              }

              if (base_self.data.detail__detail) {
                base_self.detail__detail = true;
              }
          }
        },
        created() {
            window.EditCategory = this;
            base_self = this;
            base_self.initValues()
            base_self.getStores()
            base_self.getStoreOutlays()
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
        
    }
</style>